import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h.5m3 0h1.5m3 0h6","key":"svg-0"}],["path",{"d":"M15 16l4 -4","key":"svg-1"}],["path",{"d":"M15 8l4 4","key":"svg-2"}]]

const IconArrowNarrowRightDashed = createReactComponent('outline', 'arrow-narrow-right-dashed', 'ArrowNarrowRightDashed', __iconNode);

export default IconArrowNarrowRightDashed;